import {
  ContainerData,
  ContainerFolderStructure,
  MetadataTemplateItem,
} from "../../../api/data-types";
import { StorageAPIClient } from "../../../api/storage-api-client";

export function pathToArray(path: string) {
  const pathElements = path.split("/").filter((element) => element !== "");
  return pathElements;
}

export function getContainerList(context?: string): Promise<string[]> {
  return StorageAPIClient.getContainers(context)
    .then((response) => {
      const list: string[] = response.data.data;
      return list;
    })
    .catch((error) => {
      console.error("Error fetching containers:", error);
      return [];
    });
}
export function getContainerData(
  containerName: string
): Promise<ContainerData> {
  let containerData = new ContainerData("", "", []);
  return StorageAPIClient.getContainerInformation(containerName)
    .then((response) => response.data)
    .then((json) => {
      if (json.succeeded) {
        containerData.containerName = json.data.containerName;
        const folderPattern = json.data.configuration.folderPattern
          ? String(json.data.configuration.folderPattern)
          : "";
        containerData.folderStructure = new ContainerFolderStructure(
          folderPattern
        );
        if (json.data.configuration.validateMetadataTemplate) {
          containerData.metadataTemplate =
            json.data.configuration.metadataTemplate
              .filter((item: any) => item.key && typeof item.key === "string")
              .map(
                (item: any) =>
                  new MetadataTemplateItem(
                    item.key,
                    item.required,
                    item.defaultValue,
                    item.readOnly,
                    item.dataType,
                    true
                  )
              );
        }
      }
      return containerData;
    })
    .catch((error) => {
      console.error("Container information request error: ", error);
      return containerData;
    });
}

export function loadTheOnlyContainer(
  container: string,
  loadContainer: (containerName: string) => Promise<void>
): Promise<void> {
  return loadContainer(container);
}

export const wasChangeSignificant = (
  oldSearchParams: URLSearchParams,
  searchParams: URLSearchParams
): boolean => {
  if (
    oldSearchParams.get("container") === searchParams.get("container") &&
    oldSearchParams.get("folder") === searchParams.get("folder") &&
    oldSearchParams.get("limit") !== searchParams.get("limit")
  ) {
    return false;
  }
  return true;
};

export const limit_options: number[] = [5, 20, 100, 1000];
